export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-keep-learning-3de07167d8119fc1a8b1ca0c40ccaf5d.jpg";